<script>
// @ts-nocheck

    export let title = null
    export let style = ''
    export let icon = null
    import { createEventDispatcher } from 'svelte'
    import { clickOutside } from '$lib/utils'
    const dispatch = createEventDispatcher()
    function onClickOption() {
        dispatch('option')
    }
    function onClickOut() {
        dispatch('clickout')
    }
</script>

<div class="content" {style} use:clickOutside on:clickout={onClickOut}>
    {#if title}
        <span class="title">
            <span class="element">
                {#if icon}
                    <svelte:component this={icon} size={32} />
                {/if}
                {title}
            </span>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
                class="element"
                style="cursor: pointer; margin-right: 15px"
                on:click={onClickOption}
            >
                <slot name="option" />
            </span>
        </span>
    {/if}
    <slot />
</div>

<style>
    .content {
        width: 100%;
        height: auto;
        display: flex;
        background: white;
        justify-content: flex-start;
        flex-direction: column;
        /* box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.5); */
    }
    div span {
        min-height: var(--min-height);
        height: var(--height);
        position: relative;
        width: 100%;
        font-family: Roboto;
        display: flex;
    }
    div span.title {
        font-size: calc(var(--value-font-size) * 1.294);
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.4px;
        display: flex;
        gap: 12px;
        text-align: left;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        border-bottom: 1px var(--color-grey-300) solid;
    }
    span.element {
        width: auto;
        display: flex;
        flex-direction: row;
        gap: 15px;
        justify-content: flex-start;
        align-items: center;
    }
</style>
